<template>
	<sf-data-table
		ref="CampaignTable"
		paging
		index
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="campaignCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		creatable
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/Campaign/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.campaignList;
		},
		campaignCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001024'), //캠페인번호
					prop: 'cmpnNo',
					width: '150px',
					sortable: false,
					highlight: true,
					align: 'center',
					clickEvent: this.openModal
				},
				{
					label: this.getMessage_('QWCC001007'), //캠페인명
					prop: 'cmpnNm',
					headerAlign: 'center',
					width: '150px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000975'), //원인부품코드
					prop: 'causPartNo',
					headerAlign: 'center',
					width: '150px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001198'), //원인부품명
					prop: 'causPartNm',
					headerAlign: 'center',
					width: '250px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000059'), //부품유형
					prop: 'partGNm',
					headerAlign: 'center',
					width: '80px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000958'), // 협력사
					prop: 'cpnyCd',
					width: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001342'), // 협력사명
					prop: 'cpnyNm',
					width: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001924'), //실납품사
					prop: 'dlvgNm',
					headerAlign: 'center',
					width: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001367'), // 귀책율(HTWO)
					prop: 'atblRt1',
					width: '110px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001368'), // 귀책율(HMC)
					prop: 'atblRt2',
					width: '110px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001369'), // 귀책율(협력사)
					prop: 'atblRt3',
					width: '110px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001370'), // 귀책율(OEM)
					prop: 'atblRt4',
					width: '110px',
					sortable: true
				},
				{
					label: '',
					minWidth: '',
					sortable: false
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils,
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		openModal(row) {
			// 캠페인 귀책 상세 팝업 호출
			const param = {
				title: this.getMessage_('QWCC001364'),
				cmpnNo: row.cmpnNo
			};
			this.$emit('registerRtnPart', param);
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				cmpnNo: this.searchParams.cmpnNo /*캠페인번호 */
			});

			const url = `${BASE_URL}/mqy/qlty/campaign/v1/campaigns/excel` + queryStr;

			const params = { url, columns: this.campaignCols };

			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>

<style></style>
